'use client';

import {
  ArticleCard,
  AuthorByline,
  CardDate,
  Image,
  Title,
} from '@/app_components/ArticleSections/ArticleCards/ArticleCard';
import { useContentCardTrackingData } from '@/app_lib/services/contentCardTracking';
import { getExtendedArticle } from '@/app_lib/services/contentCardTracking/utils';
import type { ArticlePreviewSmall } from '@/app_lib/types/ArticlePreview';
import type { ModuleType } from '@/app_lib/types/ContentCardTracking';

export const ArticleCardSmall = ({
  article,
  className,
  priority,
  index = 1,
  moduleType = 'featured_small',
}: {
  article: ArticlePreviewSmall;
  className?: string;
  priority?: boolean;
  index?: number;
  moduleType?: ModuleType;
}) => {
  const generateContentCardTrackingData = useContentCardTrackingData();

  return (
    <ArticleCard
      className={className}
      variant='small'
    >
      <Image
        contentCardTrackingData={generateContentCardTrackingData({
          article: getExtendedArticle(article),
          cardPosition: index,
          clickTarget: 'image',
          moduleType,
        })}
        image={article.image}
        imageAlt={article.imageAlt || article.title}
        priority={priority}
        url={article.url}
        variant='small'
      />
      <div className='flex flex-col flex-1 gap-lg'>
        <Title
          contentCardTrackingData={generateContentCardTrackingData({
            article: getExtendedArticle(article),
            cardPosition: index,
            clickTarget: 'headline',
            moduleType,
          })}
          title={article.title}
          url={article.url}
          variant='small'
        />
        <div className='flex flex-col'>
          <AuthorByline
            authors={article.authors}
            contentCardTrackingData={generateContentCardTrackingData({
              article: getExtendedArticle(article),
              cardPosition: index,
              clickTarget: 'author',
              moduleType,
            })}
            variant='small'
          />
          <CardDate
            dateGmt={article.dateGmt}
            variant='small'
          />
        </div>
      </div>
    </ArticleCard>
  );
};
